import { State } from './alarm.store';
import { ActionTree, Commit, Dispatch, MutationTree } from 'vuex';
import * as types from '../apm/mutation-types';
import { Alarm, AlarmParams, KeyLabel } from './alarm';

const mutations: MutationTree<State> = {
  [types.SET_CONFIGURED_ALERT](state: State, data: any): void {
    state.configuredAlert = data;
  },
  [types.SET_CONFIGURED_ALERT_TOTAL](state: State, data: any): void {
    state.configuredTotal = data;
  },
  [types.SET_ALARM](state: State, data: any): void {
    state.alarmService = data;
  },
  setAlarmTotal(state, data) {
    state.total = data;
  },
  [types.CLEAR_ALARM](state: State): void {
    state.alarmService = [];
    state.total = 0;
  },
  [types.SET_ID](state: State, data: any) {
    state.serviceId = data;
  },
  [types.SET_REFRESH_CONFIGURED_ALERTS](state: State, data: any) {
    state.refreshConfiguredAlerts = data;
  },
  // [types.SET_ALARM_DATA](state: State, res: any) {
  //   console.log("SET_ALARM_DATA", res.data)
  //   if (res.data.output) {
  //     state.exists = true;
  //     state.alarmDetails.serviceId = res.data.output._source.serviceId;
  //     state.alarmDetails.config = res.data.output._source.config;
  //     state.alarmDetails.last_update = res.data.output._source.last_update;
  //     state.metricsConfig = eval('(' + res.data.output._source.config + ')');
  //   } else {
  //     state.exists = false;
  //     state.alarmDetails.serviceId = state.serviceId;
  //     state.alarmDetails.config = '';
  //     state.alarmDetails.last_update = -1;
  //     state.metricsConfig = [];
  //   }
  // },
  [types.SET_CHOSEN_INDEX](state: State, data: any) {
    state.chosenIndex = data;
  },
  [types.SET_METRICS_CONFIG](state: State, data: any) {
    if (state.chosenIndex !== -1) {
      state.metricsConfig[state.chosenIndex] = data;
    } else {
      state.metricsConfig.push(data);
    }
    const temp = JSON.stringify(state.metricsConfig);
    state.alarmDetails.config = temp.replace(/"/g, "'");
    state.alarmDetails.serviceId = state.serviceId;
  },
  [types.DELETE_RULE](state: State, data: any) {
    if (data > -1) {
      state.metricsConfig.splice(data, 1);
      const temp = JSON.stringify(state.metricsConfig);
      state.alarmDetails.config = temp.replace(/"/g, "'");
    }
  },
  [types.DELETE_STATE_RULE](state: State) {
    state.metricsConfig.pop();
  },
  [types.GET_NOTIFICATION_FORM](state: State) {
    state.showNotification = true;
    state.showForm = false;
    state.showAlerts = false;
    state.showTimeZone = false;
    state.showTimeZoneeditPage = false;
    state.headerTag = 'Notification Alerts';
  },
  [types.SET_NOTIFICATION_CHANNELS](state: State, res: any) {
    if (res) {
      state.existsNotification = true;
      state.notificationChannels.serviceId = res.serviceId;
      state.notificationChannels.webhook = res.webhook;
      state.notificationChannels.email = res.email;
      state.notificationChannels.slack = res.slack;
      state.notificationChannels.last_update = res.last_update;
    } else {
      state.existsNotification = false;
      state.notificationChannels.serviceId = state.serviceId;
      state.notificationChannels.webhook = '';
      state.notificationChannels.email = '';
      state.notificationChannels.slack = '';
      state.notificationChannels.last_update = -1;
    }
  },
  [types.SET_ALARM_CAPABILITY](state: State, data: KeyLabel) {
    state.currentCapability = data;
  },
  [types.SET_CURRENT_APPLICATION](state: State, data: KeyLabel) {
    state.currentApplication = data;
  },
  [types.SET_ALARM_APPLICATIONS](state: State, data: KeyLabel[]) {
    state.alarmApplications = data;
  }
};

export default mutations;
